// @ts-nocheck
// TODO: tighten types after migration
import React from "react";
import { Helmet } from "react-helmet";
import Header from "../Header";
import Footer from "../footer";
import AllProducts from "./AllProducts";
import "./Store.css";
import { generateStoreStructuredData } from "../utils/structuredData";

export default function Store(){
    const storeSchema = generateStoreStructuredData();

    return(
        <div className="store-page min-h-screen flex flex-col">
            <Helmet>
                <title>Store – Books, Digital Products & Merchandise | Hari Vishnu</title>
                <meta name="description" content="Shop Hari Vishnu's curated store for books, digital products, and physical merchandise. Quality products with secure checkout via Razorpay." />
                <meta name="keywords" content="store, shop, books, digital products, merchandise, Hari Vishnu" />
                <link rel="canonical" href="https://store.harivishnu.in" />
                <meta name="robots" content="index,follow" />

                {/* Open Graph */}
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://store.harivishnu.in" />
                <meta property="og:title" content="Store – Books, Digital Products & Merchandise | Hari Vishnu" />
                <meta property="og:description" content="Shop Hari Vishnu's curated store for books, digital products, and physical merchandise." />
                <meta property="og:image" content="https://www.harivishnu.in/images/home_images/Logo.png" />
                <meta property="og:site_name" content="Hari Vishnu" />

                {/* Twitter */}
                <meta property="twitter:card" content="summary_large_image" />
                <meta property="twitter:url" content="https://store.harivishnu.in" />
                <meta property="twitter:title" content="Store – Books, Digital Products & Merchandise | Hari Vishnu" />
                <meta property="twitter:description" content="Shop Hari Vishnu's curated store for books, digital products, and physical merchandise." />
                <meta property="twitter:image" content="https://www.harivishnu.in/images/home_images/Logo.png" />

                {/* Structured Data */}
                <script type="application/ld+json">
                    {JSON.stringify(storeSchema)}
                </script>
            </Helmet>
            <Header />
            <main className="store-main flex-1 mb-[2%]">
                <AllProducts />
            </main>
            <Footer />
        </div>
    )
}
